'use client'

import { RenderHomeBlocks } from '@/blocks/HomePage/RenderHomeBlocks'
import { PodcastGrid } from '@/components/podcast'
import type { SpotifyEpisode } from '@/utilities/spotify'

type HomePageData = {
  blocks?: any[]
}

type Props = {
  homePage: HomePageData
  episodes?: SpotifyEpisode[]
}

export const HomePageContent = ({ homePage, episodes = [] }: Props) => {
  const blocks = (homePage as any).blocks ?? []
  const nonBlogBlocks = blocks.filter((b: any) => b.blockType !== 'blogGrid')
  const blogBlocks = blocks.filter((b: any) => b.blockType === 'blogGrid')

  return (
    <div className="min-h-screen">
      <RenderHomeBlocks blocks={nonBlogBlocks} />
      <PodcastGrid episodes={episodes} />
      <RenderHomeBlocks blocks={blogBlocks} />
    </div>
  )
}
